import React, { useState, useEffect } from 'react';
import { TextField, Button, Typography, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import FileBase from 'react-file-base64';

import useStyles from './styles';
import { createPost, updatePost } from '../../actions/posts';

const Form = ({ currentId, setCurrentId,postData,setPostData }) => {
 
  
 
  const post = useSelector((state) => (currentId ? state.posts.find((message) => message._id === currentId) : null)); //Here we are getting the post with id = currentId
 
  const dispatch = useDispatch();
 
  const classes = useStyles();

  // useEffect(() => {
  //   if (post) setPostData(post);  
  // }, [post]);
  
  useEffect(()=>{
    if(currentId) setPostData(post)
  },[post]);

  //For populating the values in the form same as that as in the post
  //When the value of post changes from nothing to the post(with id=currentid), we want to setPostData as the data of the post.

  const clear = () => {
    setCurrentId(0);  
    //When the form is empty its id should be default id which is set as 0 in app.js
    setPostData({ creator: '', title: '', message: '', tags: '', selectedFile: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();     //To Prevent Reloading of page

    //Initially the state (currentId is set to be 0)
    if (currentId === 0) { 
      dispatch(createPost(postData)); 
      clear(); 
    } else {
      //Because if we click the update button current id becomes post._id (id of that post) and then we need to perform updatePost action
      dispatch(updatePost(currentId, postData));
      clear();
    }
  };

  return (

    // In onChange functions we use ...postData so that only the targeted field get its data changed and the remaining fields stay the same and not get their data deleted as we move on to the next field
    
    <Paper className={classes.paper}>
      <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
        <Typography variant="h6">{currentId ? `Editing "${post.title?post.title:"Untitled"}"` : 'Creating a Memory'}</Typography>
        <TextField name="creator" variant="outlined" label="Creator" fullWidth value={postData.creator} onChange={(e) => setPostData({  ...postData,creator: e.target.value })} />
        <TextField name="title" variant="outlined" label="Title" fullWidth value={postData.title} onChange={(e) => setPostData({  ...postData,title: e.target.value })} />
        <TextField name="message" variant="outlined" label="Message" fullWidth multiline rows={4} value={postData.message} onChange={(e) => setPostData({...postData,message: e.target.value })} />
        <TextField name="tags" variant="outlined" label="Tags (coma separated)" fullWidth value={postData.tags} onChange={(e) => setPostData({  ...postData,tags: e.target.value.split(',') })} />
        <div className={classes.fileInput}><FileBase type="file" multiple={false} onDone={({ base64 }) => setPostData({  ...postData,selectedFile: base64 })} /></div>
        <Button className={classes.buttonSubmit} variant="contained" color="primary" size="large" type="submit" fullWidth>{!currentId?"Submit":"Update"}</Button>
        <Button variant="contained" color="secondary" size="small" onClick={clear} fullWidth>Clear</Button>
      </form>
    </Paper>
  );
};

export default Form;